import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "concordance-result-item" }
const _hoisted_2 = { class: "result-header" }
const _hoisted_3 = { class: "header-column" }
const _hoisted_4 = { class: "header-label" }
const _hoisted_5 = { class: "header-value" }
const _hoisted_6 = { class: "header-column" }
const _hoisted_7 = { class: "header-label" }
const _hoisted_8 = { class: "header-value" }
const _hoisted_9 = { class: "header-column" }
const _hoisted_10 = { class: "header-label" }
const _hoisted_11 = { class: "header-value" }
const _hoisted_12 = { class: "result-row" }
const _hoisted_13 = { class: "row-label" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "result-row" }
const _hoisted_16 = { class: "row-label" }
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('concordanceSearch.projectCode')) + ":", 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.result.projectCode), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('concordanceSearch.createdBy')) + ":", 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.result.createdBy), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('concordanceSearch.on')) + ":", 1),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDate(_ctx.result.createdOn)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('segmentSearch.source')) + ":", 1),
      _createElementVNode("span", {
        class: "row-text",
        innerHTML: _ctx.highlightedSourceText
      }, null, 8, _hoisted_14)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('segmentSearch.target')) + ":", 1),
      _createElementVNode("span", {
        class: "row-text",
        innerHTML: _ctx.highlightedTargetText
      }, null, 8, _hoisted_17)
    ])
  ]))
}